import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) return;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const previousHtmlScrollBehavior = html.style.scrollBehavior;
    const previousBodyScrollBehavior = body.style.scrollBehavior;

    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";

    const target = hash ? document.getElementById(hash.slice(1)) : null;

    const scrollToTop = () => {
      const el = hash ? document.getElementById(hash.slice(1)) : target;
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top, left: 0, behavior: "auto" });
        return true;
      }
      // Only jump to the top when there is no hash target at all. When a hash is
      // present but the element isn't mounted yet, keep polling without forcing
      // the viewport to the top on every tick, which would yank away user scroll.
      if (!hash) {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        html.scrollTop = 0;
        body.scrollTop = 0;
      }
      return !hash;
    };

    scrollToTop();
    // Retry while the target may still be mounting (async i18n, lazy content)
    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (scrollToTop() || attempts > 40) {
        window.clearInterval(retry);
      }
    }, 50);

    return () => {
      window.clearInterval(retry);
      html.style.scrollBehavior = previousHtmlScrollBehavior;
      body.style.scrollBehavior = previousBodyScrollBehavior;
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
